/*
 * @Author= Dzy
 * @Date= 2022-07-15 10=51=51
 * @LastEditors: xiangwenheng
 * @LastEditTime: 2023-02-23 15:14:33
 * @Description= 全局变量声明
 */

// 运行模式
export const RUNMODE = {
  SINGLE: 1,
  DIVIDE: 2
}

export const API_AUTH = '/api/auth'
export const API_FILE = '/api/file/center'

// 登录认证
export const API_SSO = '/api/sso'
export const API_UC_OSS = '/api/uc/oss'
export const API_BASE = '/api/busi/web'
// 管理机构接口
export const API_BASE_ADMIN = '/api/busi/web/admin'
// K12接口
export const API_BASE_K12 = '/api/busi/web/k12'
// gx接口
export const API_BASE_GX = '/api/busi/web/gx'
// nf社区接口
export const API_BASE_NF = '/api/busi/web/nf'

// 厂商接口
export const API_BASE_CS = '/api/oper/web/cs'
// 租户接口
export const API_BASE_ZH = '/api/oper/web/zh'

// 公共接口
export const API_UC = '/api/uc/web'

export const VERSION_1 = '/v1'
export const VERSION_2 = '/v2'
export const VERSION_3 = '/v3'

export const RES_TIS_FILE_SIZE_LIMIT = 20 * 1024 ** 3 // 20GB机构资源容量限制 20GB

export const UPLOAD_TIPS = {
  IMAGE: '支持上传PNG、JPG格式图片，且图片小于5M。',
  VIDEO: '支持上传mp4格式，且视频小于2G。',
  AUDIO: '支持上传MP3格式，且音频小于20M'
}

// v2qiniu文件base路径
// export const QINIU_BASE_URL = 'http://adl-ssp.s3.cn-south-1.qiniucs.com/'
export const QINIU_BASE_URL = 'https://f.nezhasport.com/'

export const USER_IDENTITY = ['', '教职工', '学生', '一般用户', '管理员', '家长']

export const SEC_CODE_INDEX = ['XX', 'CZ', 'GZ']
export const SEC_CODE = [
  { key: 'XX', name: '小学' },
  { key: 'CZ', name: '初中' },
  { key: 'GZ', name: '高中' }
]

// 领域类型键值对
export const DOMAIN = [
  { key: 'K12', name: '教育-K12' },
  { key: 'GX', name: '教育-高校' },
  { key: 'QY', name: '企业' } // 暂时不管教培 // { //   key: 'JP', //   name: '教培' // }
]

// 机构类型
export const ORG_TYPE = [
  { key: '10', name: '管理机构' },
  { key: '21', name: 'K12' },
  { key: '22', name: '高校' },
  { key: '30', name: '企业' }
]

export const MENU_PATH = ['/add', '/edit', '/detail', '/members']

export const USER_SEX = [
  { key: 1, name: '男' },
  { key: 2, name: '女' },
  { key: 9, name: '其他' }
]

export const UPGRADE_TIME = 20966400000 //默认升学日期：9.1
export const GRADUATION_TIME = 15609600000 // 默认毕业日期：7.1

export const FileSizeLimitByType = {
  image: 5 * 1024 ** 2, //图片大小限制
  video: 500 * 1024 ** 2, //视频大小限制
  audio: 50 * 1024 ** 2, //音频大小限制
  gif: 10 * 1024 ** 2 //gif大小限制
}
//状态
export const CONDITION = [
  { key: '1', name: '启用' },
  { key: '0', name: '停用' }
]
// 机构类型键值对
export const ORGTYPE = [
  {
    key: '1',
    name: '区域'
  },
  {
    key: '2',
    name: '终端'
  }
]

// 业务中心用户创建业务系统用户使用身份类型
export const MISSION_USER_TYPE = {
  // 通用：用于列表选择
  COMMON: [
    { key: '1', name: '教职工' },
    { key: '2', name: '学生' },
    { key: '4', name: '管理员' },
    { key: '5', name: '家长' }
  ],
  // K12领域 选择身份
  K12: [
    { key: '1', name: '教职工' },
    { key: '2', name: '学生' },
    { key: '5', name: '家长' }
  ],
  // 高校领域 选择身份
  GX: [
    { key: '1', name: '教职工' },
    { key: '2', name: '学生' },
    { key: '5', name: '家长' }
  ],
  // 企业领域 选择身份
  QY: [{ key: '1', name: '教职工' }]
}

// 百科类型
export const WIKI_TYPE = [
  { name: '图文', key: 1 },
  { name: '视频', key: 2 }
]
//应用终端列表
export const TERMINALS = [
  { name: '小程序', key: 1 },
  { name: '智慧屏', key: 2 },
  { name: '移动站（教育）', key: 3 },
  { name: '田径杆', key: 4 },
  { name: '体测室', key: 5 },
  { name: '移动站（体培）', key: 6 },
  { name: '通用杆', key: 7 },
  { name: 'app(ios)', key: 8 },
  { name: 'app(android)', key: 9 }
  // { name: '其他', key: 99 }
]

//激活码是否使用
export const USECODESTUTAS = [
  { key: '1', name: '否' },
  { key: '2', name: '是' }
]

// 赛事级别
export const COMPETITION_ORGLEVEL = {
  // 高校赛事级别
  GX: [
    { key: 1, name: '校级' },
    { key: 2, name: '区县级' },
    { key: 3, name: '市级' },
    { key: 4, name: '其他' }
  ],
  // 企业赛事级别
  QY: [
    { key: 1, name: '部门' },
    { key: 2, name: '公司' },
    { key: 3, name: '集团' },
    { key: 4, name: '其他' }
  ],
  // K12赛事级别
  K12: [
    { key: 1, name: '校级' },
    { key: 4, name: '其他' }
  ]
}

// 赛事类型
export const COMPETITION_TYPE = [
  { key: 1, name: '线上赛' },
  { key: 2, name: '闯关挑战' }
]

// 赛事/计划 状态
export const COMPETITIONorPLAN_STATUS = [
  { key: 1, name: '未开始' },
  { key: 2, name: '进行中' },
  { key: 3, name: '已结束' },
  { key: 4, name: '提前结束' }
]

// 项目运动形式
export const SPORTMODEL = [
  [
    { key: 1, name: '计时' },
    { key: 2, name: '计数' },
    { key: 3, name: '无限制' }
  ],
  [
    { key: 1, name: '计时' },
    { key: 3, name: '无限制' }
  ],
  [
    { key: 1, name: '计时' },
    { key: 2, name: '计数' }
  ]
]

export const PARENT_RELATION = [
  { value: 0, label: '其他监护人' },
  { value: 1, label: '爸爸' },
  { value: 2, label: '妈妈' },
  { value: 3, label: '爷爷' },
  { value: 4, label: '奶奶' },
  { value: 5, label: '外公' },
  { value: 6, label: '外婆' }
]

// 应用终端 赛事业务上的枚举
// K12：智慧屏K12、移动端-小程序、移动端-android、移动端-ios
// 高校：智慧屏GX、移动端-小程序、移动端-android、移动端-ios
export const RANK_APPCODES = {
  10: [],
  41: [],
  21: ['101101', '101001', '101002', '101003'],
  22: ['101201', '101001', '101002', '101003']
}
